import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import ComponentsService from "../../../services/ComponentsService";
import {
  ComponentTemplateDto,
  IPaginatedListOfComponentTemplateDto,
  PaginatedListOfComponentTemplateBriefDto,
} from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../ComponentTemplateLibrary";
import { INFINITE_PAGINATED_DATA_UPDATERS } from "../../../utils/optimisticUpdate";
import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import { COMPONENT_TEMPLATES_LIST_QUERY_KEY } from "../../component-template/ComponentTemplateDialog";
import { ComponentType } from "../../../constants";

//Use to delete component template from the component template library page
export const useDeleteComponentTemplateLibraryMutation = (
  componentType: ComponentType,
) => {
  const filterOutTemplate = INFINITE_PAGINATED_DATA_UPDATERS.filterOutItem;
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    successToastMessage: "Template removed",
    queryKey: [COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY, { componentType }],
    mutationFn: ComponentsService.removeComponentTemplate,
    optimisticUpdater: {
      updateFn: (
        oldData: InfiniteData<IPaginatedListOfComponentTemplateDto>,
        id,
      ) => filterOutTemplate<ComponentTemplateDto>(oldData, id),
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
    exactQueryKey: false,
    options: {
      onSuccess(_, variables) {
        queryClient.setQueryData(
          [COMPONENT_TEMPLATES_LIST_QUERY_KEY, { componentType }],
          (oldData: PaginatedListOfComponentTemplateBriefDto) => {
            if (!oldData) return oldData;
            return PaginatedListOfComponentTemplateBriefDto.fromJS({
              ...oldData,
              items: oldData.items.filter((item) => item.id !== variables),
            });
          },
        );
      },
    },
  });
};
